import { combineLocationString, splitLocationString } from '../../../util/index';
import { AccessToken } from '../../models/index';
import { UseCase } from '../UseCase';
import { DecodeAccessToken } from './DecodeAccessToken';
import { SetOAuthError } from './SetOAuthError';
import { SetOAuthState } from './SetOAuthState';

export class ParseAccessToken implements UseCase<Location, AccessToken | undefined> {
    private setOAuthState = new SetOAuthState();
    private setOAuthError = new SetOAuthError();
    private decodeAccessToken = new DecodeAccessToken();

    execute(location: Location): AccessToken | undefined {
        if (location.hash || location.search) {
            const map = splitLocationString(location.hash || location.search);
            if (map.access_token || map.error || map.error_description) {
                const params = { ...map };

                // Clean the URL before decoding or storing anything, so a failure
                // in either step cannot leave the token in the URL.
                if (location.hash) {
                    [
                        'access_token',
                        'token_type',
                        'state',
                        'expires_in',
                        'jti',
                        'error',
                        'error_description'
                    ].forEach((remove) => {
                        delete map[remove];
                    });

                    const restore = combineLocationString(map);
                    location.hash = restore ? `#${restore}` : '';

                    // Also clean the address bar, for pages other than /login. Use
                    // replaceState: assigning window.location.hash adds a history
                    // entry, and Back would return to the URL holding the token.
                    const url = new URL(window.location.href);
                    url.hash = restore;
                    window.history.replaceState(window.history.state, '', url.href);
                }

                let access: AccessToken | undefined;
                if (params.access_token) {
                    // TODO: Re-implement in DASH-782
                    // const state = this.getOAuthState.execute();
                    // if (state && params.state !== state) {
                    //   this.setOAuthState.execute(false);
                    //   this.setOAuthError.execute('OAuth state does not match');
                    // } else {
                    access = this.decodeAccessToken.execute(params.access_token);
                    this.setOAuthState.execute(false);
                    this.setOAuthError.execute(undefined);
                    // }
                } else {
                    this.setOAuthError.execute(params.error_description || params.error);
                }

                return access;
            }
        }
    }
}
